import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_licenseplate_navigation_listService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotId?: number, materialId?: number, locationId?: number, projectId?: number, full_text_search?: string, license_plate?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, LicensePlate?: { Id?: number, LocationId?: number, LookupCode?: string }, Lot?: { LookupCode?: string, MaterialId?: number, Material?: { Id?: number, ProjectId?: number } } }[] }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_licenseplate_navigation_list/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lotId?: number, materialId?: number, locationId?: number, projectId?: number, full_text_search?: string, license_plate?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, LicensePlate?: { Id?: number, LocationId?: number, LookupCode?: string }, Lot?: { LookupCode?: string, MaterialId?: number, Material?: { Id?: number, ProjectId?: number } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_licenseplate_navigation_list/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lotId?: number, materialId?: number, locationId?: number, projectId?: number, full_text_search?: string, license_plate?: number, $keys: { LicensePlateId?: number, LotId?: number, PackagedId?: number }[] }): 
  Promise<{ result: { LicensePlateId?: number, LotId?: number, PackagedId?: number, LicensePlate?: { Id?: number, LocationId?: number, LookupCode?: string }, Lot?: { LookupCode?: string, MaterialId?: number, Material?: { Id?: number, ProjectId?: number } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_licenseplate_navigation_list/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotId?: number, materialId?: number, locationId?: number, projectId?: number, full_text_search?: string, license_plate?: number    }) {
      return false;
    }
}
